
import { useState } from 'react';

export default function Home() {
  const [selectedModule, setSelectedModule] = useState<number | null>(null);

  const modules = [
    {
      id: 1,
      title: "外贸基础入门",
      subtitle: "夯实基础",
      duration: "1.5小时",
      icon: "ri-global-line",
      color: "from-blue-500 to-blue-600",
      points: [
        '外贸全流程概述：从"询盘"到"核销退税"，用一张图梳理整个外贸链条',
        "核心术语解析：FOB, CIF, CFR, EXW等常用贸易术语的风险和责任划分",
        "关键单证简介：发票、箱单、提单、原产地证、报关单等的作用与制作要点",
        "付款方式与风险：T/T, L/C, D/P等的流程、成本和风险对比"
      ]
    },
    {
      id: 2,
      title: "一般贸易深度解析",
      subtitle: "传统主力",
      duration: "1.5小时",
      icon: "ri-building-line",
      color: "from-green-500 to-green-600",
      points: [
        "什么是一般贸易？定义、本质（单笔交易、依法退税）",
        "核心优势：流程规范、适用性广、可享受出口退税、品牌建设",
        "核心劣势：单证要求高、流程复杂、税务合规成本高",
        "业务流程与关键节点：重点讲解报关、退税流程及所需单证",
        "适用场景：大中型企业、生产型企业、高货值产品、品牌产品"
      ]
    },
    {
      id: 3,
      title: "市场采购贸易方式解析",
      subtitle: "新业态利器",
      duration: "1.5小时",
      icon: "ri-shopping-cart-line",
      color: "from-purple-500 to-purple-600",
      points: [
        "什么是市场采购贸易（1039）？国家政策背景、定义",
        "核心优势：免税通关、通关便利、收汇灵活",
        "核心劣势：仅在试点区域适用、有货值限制、不产生退税",
        "业务流程：备案→交易→组货→报关→收汇",
        "适用场景：中小微企业、个体工商户、多品种小批量货物"
      ]
    },
    {
      id: 4,
      title: "对比、选择与风险防控",
      subtitle: "实战应用",
      duration: "1小时",
      icon: "ri-shield-check-line",
      color: "from-orange-500 to-orange-600",
      points: [
        '"一般贸易" vs "市场采购"对比表：从主体、额度、征税等维度对比',
        "如何选择？——决策树：产品能取得进项发票吗？",
        "常见风险与防控：一般贸易和市场采购的风险点",
        "政策滥用风险、产品侵权风险、外汇风险防控"
      ]
    },
    {
      id: 5,
      title: "案例分析与互动答疑",
      subtitle: "巩固提升",
      duration: "1小时",
      icon: "ri-question-answer-line",
      color: "from-red-500 to-red-600",
      points: [
        "案例1：小家电生产企业，年出口额500万美元的出口方案",
        "案例2：跨境电商卖家采购1000种小商品的便捷出口方式",
        "案例3：20万美元订单中部分产品无发票的出口方案设计",
        "自由问答与讨论：解答学员实际工作中遇到的问题"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                <i className="ri-graduation-cap-line text-white text-xl"></i>
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "Pacifico, serif" }}>天健外贸培训学院</h1>
                <p className="text-sm text-gray-600">专业外贸知识培训平台</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <button className="px-4 py-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-phone-line mr-2"></i>
                联系客服
              </button>
              <button className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                立即报名
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/c7e0f2ba1712b2450dcfde1e3f8d1356.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-purple-900/70"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-6 py-20">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold text-white mb-6 leading-tight">
              掌握外贸核心技能
              <br />
              <span className="text-blue-300">开启国际贸易之路</span>
            </h1>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              从基础入门到实战应用，全面解析一般贸易与市场采购贸易方式，
              助您快速掌握外贸核心知识，提升业务能力
            </p>
            <div className="flex flex-wrap gap-4">
              <button 
                onClick={() => window.REACT_APP_NAVIGATE('/module1')}
                className="px-8 py-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                开始学习
              </button>
              <button className="px-8 py-4 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors backdrop-blur-sm font-semibold whitespace-nowrap cursor-pointer">
                <i className="ri-download-line mr-2"></i>
                课程大纲
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Course Overview */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">课程模块</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            5个核心模块，7.5小时深度学习，从理论到实践全面掌握外贸业务
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-16">
          <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-blue-600 text-xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">7.5小时</h3>
            <p className="text-gray-600">总学习时长</p>
          </div>
          <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-book-line text-green-600 text-xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">5个模块</h3>
            <p className="text-gray-600">核心课程模块</p>
          </div>
          <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-line text-purple-600 text-xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">1000+</h3>
            <p className="text-gray-600">学员已参与</p>
          </div>
          <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
            <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-star-line text-orange-600 text-xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">4.9分</h3>
            <p className="text-gray-600">学员满意度</p>
          </div>
        </div>

        {/* Modules */}
        <div className="space-y-6">
          {modules.map((module, index) => (
            <div key={module.id} className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <div 
                className={`bg-gradient-to-r ${module.color} p-6 cursor-pointer`}
                onClick={() => setSelectedModule(selectedModule === module.id ? null : module.id)}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                      <i className={`${module.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <div className="flex items-center space-x-3 mb-2">
                        <span className="bg-white/20 text-white px-3 py-1 rounded-full text-sm font-medium">
                          模块{index + 1}
                        </span>
                        <span className="bg-white/20 text-white px-3 py-1 rounded-full text-sm font-medium">
                          {module.duration}
                        </span>
                      </div>
                      <h3 className="text-2xl font-bold text-white mb-1">{module.title}</h3>
                      <p className="text-white/80 text-lg">{module.subtitle}</p>
                    </div>
                  </div>
                  <div className="text-white">
                    <i className={`${selectedModule === module.id ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-2xl`}></i>
                  </div>
                </div>
              </div>
              
              {selectedModule === module.id && (
                <div className="p-8">
                  <h4 className="text-lg font-semibold text-gray-900 mb-6">内容要点：</h4>
                  <div className="space-y-4">
                    {module.points.map((point, pointIndex) => (
                      <div key={pointIndex} className="flex items-start space-x-3">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                        <p className="text-gray-700 leading-relaxed">{point}</p>
                      </div>
                    ))}
                  </div>
                  <div className="mt-8 flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                      <button 
                        onClick={() => {
                          if (module.id === 1) {
                            window.REACT_APP_NAVIGATE('/module1');
                          } else if (module.id === 2) {
                            window.REACT_APP_NAVIGATE('/module2');
                          } else if (module.id === 3) {
                            window.REACT_APP_NAVIGATE('/module3');
                          } else if (module.id === 4) {
                            window.REACT_APP_NAVIGATE('/module4');
                          } else if (module.id === 5) {
                            window.REACT_APP_NAVIGATE('/module5');
                          }
                        }}
                        className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-play-circle-line mr-2"></i>
                        开始学习
                      </button>
                      <button className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                        <i className="ri-bookmark-line mr-2"></i>
                        收藏
                      </button>
                    </div>
                    <div className="text-sm text-gray-500">
                      预计学习时间：{module.duration}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 py-16">
        <div className="max-w-4xl mx-auto text-center px-6">
          <h2 className="text-4xl font-bold text-white mb-4">
            立即开始您的外贸学习之旅
          </h2>
          <p className="text-xl text-blue-100 mb-8 leading-relaxed">
            专业讲师授课，实战案例分析，助您快速掌握外贸核心技能
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button className="px-8 py-4 bg-white text-blue-600 rounded-lg hover:bg-gray-50 transition-colors font-semibold whitespace-nowrap cursor-pointer">
              <i className="ri-user-add-line mr-2"></i>
              立即报名
            </button>
            <button className="px-8 py-4 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors backdrop-blur-sm font-semibold whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line mr-2"></i>
              咨询客服
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                  <i className="ri-graduation-cap-line text-white"></i>
                </div>
                <h3 className="text-xl font-bold" style={{ fontFamily: "Pacifico, serif" }}>天健外贸培训学院</h3>
              </div>
              <p className="text-gray-400 mb-4">专业的外贸知识培训平台，助您成为外贸专家</p>
              <div className="flex space-x-4">
                <i className="ri-wechat-line text-xl text-gray-400 hover:text-white cursor-pointer transition-colors"></i>
                <i className="ri-qq-line text-xl text-gray-400 hover:text-white cursor-pointer transition-colors"></i>
                <i className="ri-mail-line text-xl text-gray-400 hover:text-white cursor-pointer transition-colors"></i>
              </div>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">课程内容</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">外贸基础入门</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">一般贸易解析</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">市场采购贸易</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">风险防控</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">学习支持</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">在线答疑</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">实战案例</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">学习资料</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">证书认证</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">快速链接</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">关于我们</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">联系方式</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">服务条款</a></li>
                <li><a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Made with Readdy</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 外贸培训学院. 保留所有权利.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
